import _ from '@lodash';
import XAPPService from 'app/Core/services/XAPPService';
export const GET_EMPRESAPESSOAJORNADA = '[EMPRESAPESSOAJORNADA APP] GET EMPRESAPESSOAJORNADA';
export const REMOVE_EMPRESAPESSOAJORNADA = '[EMPRESAPESSOAJORNADA APP] REMOVE EMPRESAPESSOAJORNADA';
export const ADD_EMPRESAPESSOAJORNADA = '[EMPRESAPESSOAJORNADA APP] ADD EMPRESAPESSOAJORNADA';
export const EMPRESAPESSOAJORNADA_WARNING = '[EMPRESAPESSOAJORNADA APP] EMPRESAPESSOAJORNADA WARNING';
export const EMPRESAPESSOAJORNADA_INFO = '[EMPRESAPESSOAJORNADA APP] EMPRESAPESSOAJORNADA INFO';
export const EMPRESAPESSOAJORNADA_ERROR = '[EMPRESAPESSOAJORNADA APP] EMPRESAPESSOAJORNADA ERROR';

const getState = [
    'idpessoaformulario',
    'idparent',
    'formulario',
    'statusregistro',
];

const AddState = [
    'idparent',
    'tipo',
    'idpessoa',
    'formulario',
];

export function get(_AAction, _AParams, _AID) {
    return (dispatch) => {
        var AConditionsAND = [
            { "Campo": "idparent", "Operador": "=", "Valor": _AID },
            { "Campo": "tipo", "Operador": "=", "Valor": 126 }
        ];
        var AConditionsOR = [];
        var AActions = [];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "EmpresaPessoaJornada", AActions, "spvwpessoaformulario", getState, _AAction, AConditionsAND, AConditionsOR)


        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAPESSOAJORNADA,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAPESSOAJORNADA_ERROR,
                    payload: error
                });
            });
    };
}

export function save(_AValue, _AParams, _AID) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var AAction = "INSERIR";

        if (!_.isUndefined(_AValue.idpessoaformulario) && !_.isNull(_AValue.idpessoaformulario)) {
            AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
            AAction = "ATUALIZAR";
        }

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", AAction, _AValue, "idpessoaformulariorelacionamento", AConditionsAND, AConditionsOR, 1, AddState);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAPESSOAJORNADA_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => dispatch(get("SELECIONAR", _AParams, _AID)))
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAPESSOAJORNADA_INFO,
                            payload: response.info,
                            id: response.ultimoidinserido
                        })
                    ]).then(() => dispatch(get("SELECIONAR", _AParams, _AID)))
                }
            }).catch(error => {
                return dispatch({
                    type: EMPRESAPESSOAJORNADA_ERROR,
                    payload: error
                });
            });
    };
}

export function clearReducer() {
    return {
        type: GET_EMPRESAPESSOAJORNADA,
        payload: null
    }
}